import React from 'react';
import ForComapnyDetails from './components/ForComapnyDetails';
import FooterSection from '../FooterSection';

const ForCompany: React.FC = () => {
  return (
    <div>
        <ForComapnyDetails />
        <FooterSection />
    </div>
  );
};

export default ForCompany;
